module.exports = __webpack_public_path__ + "static/media/Luxembourg.57c13ca3.png";